import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useEffect, useState } from "react";

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
  },
});

let id = 0;
function createData(cuota, fecha, capital, interes, mora, multa, iva, cargos, total, pagado, saldo, dias) {
  id += 1;
  return { cuota, id, fecha, capital, interes, mora, multa, iva, cargos, total, pagado, saldo, dias };
}

const useStyles = makeStyles({
  tableCell: {
    padding: "0px 0px 0px 0px",
    margin: 0
  }
});
function Computertable({ data, type }) {
  console.log(data);
  const classes = useStyles();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setRows([]);
    for (const property in data) {
      setRows(rows => [...rows, createData(data[property].number, data[property].date, data[property].capital, data[property].interest, data[property].late_fee, data[property].penalty_fee, data[property].iva, data[property].administrative, data[property].totalT, data[property]['capital-balance'], data[property].diff, data[property].days)]);
    }
  }, [data]);

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            {type === 'loan' ? <TableCell className={classes.tableCell} align="center" style={{ width: '1%' }}>NO.</TableCell> : <></>}
            <TableCell className={classes.tableCell} align="center" style={{ width: '8%' }}>FECHA</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '11%' }}>CAPITAL</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '9%' }}>INTERESES</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '8%' }}>MORA</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '8%' }}>MULTA</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '10%' }}>IVA</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '8%' }}>CARGOS ADMIN.</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '13%' }}>TOTAL</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '8%' }}>SALDO PAGADO</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '12%' }}>SALDO CAPITAL</TableCell>
            <TableCell className={classes.tableCell} align="center" style={{ width: '4%' }}>DÍAS ATRASADOS&nbsp;&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id}>
              {type === 'loan' ? <TableCell align="right">{row.cuota}</TableCell> : <></>}
              <TableCell align="right">{row.fecha.length === 0 ? row.fecha : new Date(row.fecha.split('/')[1] + '/' + row.fecha.split('/')[0] + '/' + row.fecha.split('/')[2]).toLocaleDateString('en-GB', { year: '2-digit', month: '2-digit', day: '2-digit' })}</TableCell>
              <TableCell align="right">{row.capital}</TableCell>
              <TableCell align="right">{row.interes}</TableCell>
              <TableCell align="right">{row.mora}</TableCell>
              <TableCell align="right">{row.multa}</TableCell>
              <TableCell align="right">{row.iva}</TableCell>
              <TableCell align="right">{row.cargos}</TableCell>
              <TableCell align="right">{row.total}</TableCell>
              <TableCell align="right">{row.pagado}</TableCell>
              {Object.prototype.hasOwnProperty.call(row.saldo, 'red') ? <TableCell align="right" style={{ color: 'red' }}>{row.saldo.red}</TableCell> : <TableCell align="right">{row.saldo.black}</TableCell>}
              <TableCell align="right">{row.dias}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}


export default withStyles(styles)(Computertable);
